import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import Tooltip from '@Components/Tooltip';
import ColumnHeaderCell from '@Pages/Heatmap/HeatmapTable/Header/ColumnHeaderCell';
import RowHeaderCell from '@Pages/Heatmap/HeatmapTable/Header/RowHeaderCell';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

const BaseHeader = forwardRef(
  (
    {
      totalItems,
      items,
      loaded,
      selectHeaderItem,
      selectedHeaderItems,
      hoveredItem,
      showStructure,
      handleHover,
      isRow,
      containerRef,
      startPoint,
      cellsToShow,
      style,
      headerClassName,
      headerContainerClassName,
      isVertical,
      height,
      width,
    },
    selfRef
  ) => {
    const HeaderCell = isRow ? RowHeaderCell : ColumnHeaderCell;
    const viewIndexes = range(startPoint, Math.min(startPoint + cellsToShow, totalItems), 1);

    useEffect(() => {
      Tooltip.rebuild();
    }, [startPoint]);

    return (
      <div className={headerClassName} style={style} ref={selfRef}>
        <div className={headerContainerClassName} ref={containerRef}>
          {viewIndexes.map((viewIndex, visibleIndex) => (
            <HeaderCell
              key={viewIndex}
              index={viewIndex}
              visibleIndex={visibleIndex}
              cell={items[viewIndex]}
              height={height}
              width={width}
              isRow={isRow}
              isVertical={isVertical}
              selectHeaderItem={selectHeaderItem}
              selectedHeaderItems={selectedHeaderItems}
              hoveredItem={hoveredItem}
              handleHover={handleHover}
              showStructure={showStructure}
            />
          ))}
        </div>
        <div>{!loaded && <SimpleSpinner />}</div>
      </div>
    );
  }
);

BaseHeader.propTypes = {
  totalItems: PropTypes.number,
  items: PropTypes.object.isRequired,
  loaded: PropTypes.bool.isRequired,
  selectHeaderItem: PropTypes.func,
  selectedHeaderItems: PropTypes.array.isRequired,
  hoveredItem: PropTypes.object,
  showStructure: PropTypes.bool,
  handleHover: PropTypes.func,
  isRow: PropTypes.bool,
  containerRef: PropTypes.object,
  startPoint: PropTypes.number,
  cellsToShow: PropTypes.number,
  style: PropTypes.object,
  headerClassName: PropTypes.string,
  headerContainerClassName: PropTypes.string,
  isVertical: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default BaseHeader;
